import React from "react";
import { Auth } from "aws-amplify";
import { useHistory, Link } from "react-router-dom";
import { useRequest } from "ahooks";
import AuthLayout from "../../layouts/AuthLayout";
import { toast } from "react-toastify";
import { useUser } from "../../contexts";
import { me } from "../../api";
import { UserData } from "../../interfaces";
import { useTranslation } from "react-i18next";
import { Button, PasswordInput, Text, TextInput } from "@mantine/core";

const Login: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [, dispatchUser] = useUser();

  const handleLogin = async ({
    email,
    password,
  }: {
    email: string;
    password: string;
  }) => {
    try {
      await Auth.signIn(email, password);

      dispatchUser({
        type: "SIGN_IN",
        user: (await me()) as UserData,
      });

      history.push("/dashboard");
    } catch (err: any) {
      toast.error(err?.message);
      return false;
    }
    return true;
  };

  const loginAction = useRequest((values) => handleLogin(values), {
    manual: true,
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const email = e.target["email"].value;
    const password = e.target["password"].value;

    loginAction.run({ email, password });
  };

  return (
    <AuthLayout>
      <div className="card">
        <div className="text-center mb-20">
          <p style={{ fontSize: 22 }} className="f-w-500">
            {t("login")}
          </p>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__row">
            <Text>{t("email")}</Text>
            <TextInput
              name="email"
              type="email"
              required
              placeholder={t("email")}
            />
          </div>
          <div className="form__row">
            <Text>{t("password")}</Text>
            <PasswordInput
              name="password"
              required
              placeholder={t("password")}
            />
          </div>
          <div className="form__row">
            <Button
              size="lg"
              disabled={loginAction.loading}
              loading={loginAction.loading}
              type="submit"
              fullWidth
            >
              {t("login")}
            </Button>
          </div>

          <Link className="f-w-500" to="/forgot-password">
            <Text color="blue">Forgot password?</Text>
          </Link>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Login;
